import {
  Entity, PrimaryGeneratedColumn, Column, CreateDateColumn, UpdateDateColumn, JoinColumn, ManyToOne, DeleteDateColumn,
} from 'typeorm';
import {
  IsOptional, IsBoolean, IsInt, IsDate,
} from 'class-validator';
import { Usuario } from './Usuario';
import { IntervaloRefeicao, MomentoMedicaoGlicemia } from '../types';
import { Paciente } from './Paciente';
import { Gestacao } from './Gestacao';

@Entity({ name: 'medicoes_glicemia' })
export class MedicaoGlicemia {
  @PrimaryGeneratedColumn()
  @IsOptional()
  @IsInt()
  id?: number;

  @Column()
  @IsInt()
  paciente_id: number;

  @Column()
  @IsInt()
  @IsOptional()
  gestacao_id?: number | null;

  @Column()
  @IsDate()
  data_medicao: Date;

  @Column({
    type: 'enum',
    enum: MomentoMedicaoGlicemia,
  })
  momento: MomentoMedicaoGlicemia;

  @Column({
    type: 'enum',
    enum: IntervaloRefeicao,
  })
  intervalo_refeicao: IntervaloRefeicao;

  @Column()
  @IsInt()
  medida: number;

  @Column()
  @IsOptional()
  observacoes: string | null;

  @Column()
  @IsOptional()
  justificativa?: string | null;

  @CreateDateColumn()
  @IsOptional()
  created?: Date;

  @Column()
  @IsOptional()
  created_by?: number | null;

  @DeleteDateColumn({ name: 'deleted' })
  deleted?: Date

  @Column()
  @IsOptional()
  deleted_by?: number | null;

  // RELATIONS
  @ManyToOne(() => Paciente)
  @JoinColumn({ name: 'paciente_id' })
  paciente?: Paciente;

  @ManyToOne(() => Gestacao)
  @JoinColumn({ name: 'gestacao_id' })
  gestacao?: Gestacao;

  @ManyToOne(() => Usuario, {
    eager: true,
  })
  @JoinColumn({ name: 'created_by' })
  usuario_created_by?: Usuario;

  @ManyToOne(() => Usuario)
  @JoinColumn({ name: 'deleted_by' })
  usuario_deleted_by?: Usuario;
}
